module.exports = __webpack_public_path__ + "img/Reg-4-DiscoverNew.f77d16cf.svg";